export default __webpack_public_path__ + "static/media/close_red.1730643f.svg";